











































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import EntityType from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { MessagingModule } from '@/store/modules/messaging';
import CreateConversationRequest from '@/models/Conversations/CreateConversationRequest';
import ConversationTopicDto from '@/models/ConversationTopics/ConversationTopicDto';
import ConversationTopicFirestoreDto from '@/models/ConversationTopics/ConversationTopicFirestoreDto';

@Component({
    name: 'ConversationCreate',
    components: { }

})
export default class extends GiganautVueDialog {
 
  public dialog = false;

  @Prop({required: true})
  entityType: EntityType;

  conversationTopic: ConversationTopicFirestoreDto = new ConversationTopicFirestoreDto();
  request: CreateConversationRequest = new CreateConversationRequest();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new CreateConversationRequest();
      this.conversationTopic = new ConversationTopicFirestoreDto();
    }
  }

  get loading() {
    if (this.entityType === EntityType.Worker) {
      return WorkerDetailsModule.loadingDialog;
    }
    return MessagingModule.loadingDialog;
  }

  get conversationTopics() {
    if (this.entityType === EntityType.Worker) {
      return WorkerDetailsModule.conversationTopics;
    } else {
      return [];//return MessagingModule.conversationTopics.filter(topic => topic.isEnabled && topic.isPublic);
    }
  }

  async sendMessage() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.conversationTopicId = this.conversationTopic.id;
    if (this.entityType === EntityType.Worker) {
      await WorkerDetailsModule.createConversation(this.request);
      await WorkerDetailsModule.getConversations(0);
    } else {
      //This would need worker selection
      //await MessagingModule.createConversation(request);
    }


    this.dialog = false;
  }
}
